var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSubscriptions32Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#010101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.89 18.02v-3.42-.08h-3.56v.08 3.42h-3.55v3.52h3.55v6.94h-10.66v-3.52h-3.56v3.52 3.52h17.78v-3.52-6.94h3.55v-3.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.44 21.54h3.56v3.52h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.22 21.54h3.56v3.52h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.11 13.98v3.42h3.56v-3.42h3.55v-3.52h-3.55v-6.94h10.66v3.52h3.56v-7.04h-17.78v10.46h-3.55v3.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 6.94h3.56v3.52h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.22 6.94h3.56v3.52h-3.56z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubscriptions32Px);
export default __webpack_public_path__ + "static/media/icon_subscriptions_32px.e24324151caf6df0add8ed02ff3a5bd7.svg";
export { ForwardRef as ReactComponent };